import React, { useState } from "react";
import DownloadButton from "./DownloadButton";
import { calculatePrice } from "../lib/CalculationEngine";


const alapExtrak = [
  { key: "bathroom" },
  { key: "kitchen" },
  { key: "floorHeating" },
  { key: "blinds" },
  { key: "crane" }
];

export default function CalculatorForm() {
  // --- LOCAL TRANSLATION OBJECT RESTORED ---
  const translations = {
    hu: {
      summary: "Kalkuláció összegzés",
      area: "Alapterület:",
      roof: "Tető:",
      permit: "Építési engedély:",
      distance: "Szállítási távolság:",
      design: "Tervezési mód:",
      extras: "Extrák:",
      noExtras: "Nincs extra kiválasztva",
      netto: "Nettó ár:",
      vat: "ÁFA:",
      brutto: "Bruttó ár:",
      download: "PDF letöltése",
      calc: "Kalkuláció",
      yes: "Engedélyes",
      no: "Nem engedélyes",
      title: "Hopp Homes Ár kalkulátor",
      desc: "Számítsd ki álmaid házának árát 4 egyszerű lépésben!",
      baseInfo: "Alapinformációk",
      extrasSelect: "Extrák kiválasztása",
      transportDesign: "Szállítás és tervezés",
      netArea: "Nettó hasznos m²",
      roofType: "Tetőkialakítás",
      permitLabel: "Építési engedély",
      transportDistance: "Szállítási távolság (km)",
      designMode: "Tervezési mód",
      flatRoof: "Lapostető (alapár)",
      gableRoof: "Nyeregtető (+50.000 Ft/m²)",
      permitYes: "Van (5% ÁFA)",
      permitNo: "Nincs (27% ÁFA)",
      extrasLabels: {
        bathroom: "Fürdőszoba",
        kitchen: "Konyha",
        floorHeating: "Padlófűtés",
        blinds: "Redőny + szúnyogháló",
        crane: "Daruzás"
      }
    },
    en: {
      summary: "Calculation summary",
      area: "Area:",
      roof: "Roof:",
      permit: "Permit:",
      distance: "Transport distance:",
      design: "Design mode:",
      extras: "Extras:",
      noExtras: "No extras selected",
      netto: "Net price:",
      vat: "VAT:",
      brutto: "Gross price:",
      download: "Download PDF",
      calc: "Calculate",
      yes: "With permit",
      no: "Without permit",
      title: "Hopp Homes Price Calculator",
      desc: "Calculate your dream home price in 4 easy steps!",
      baseInfo: "Basic information",
      extrasSelect: "Select extras",
      transportDesign: "Transport and planning",
      netArea: "Net area m²",
      roofType: "Roof type",
      permitLabel: "Building permit",
      transportDistance: "Transport distance (km)",
      designMode: "Design mode",
      flatRoof: "Flat roof (base)",
      gableRoof: "Gable roof (+50.000 Ft/m²)",
      permitYes: "Yes (5% VAT)",
      permitNo: "No (27% VAT)",
      extrasLabels: {
        bathroom: "Bathroom",
        kitchen: "Kitchen",
        floorHeating: "Floor heating",
        blinds: "Blinds & insect screen",
        crane: "Crane service"
      }
    },
    sk: {
      summary: "Zhrnutie kalkulácie",
      area: "Plocha:",
      roof: "Strecha:",
      permit: "Stavebné povolenie:",
      distance: "Vzdialenosť dopravy:",
      design: "Režim návrhu:",
      extras: "Príplatky:",
      noExtras: "Žiadne príplatky",
      netto: "Čistá cena:",
      vat: "DPH:",
      brutto: "Cena s DPH:",
      download: "Stiahnuť PDF",
      calc: "Vypočítať",
      yes: "S povolením",
      no: "Bez povolenia",
      title: "Kalkulačka ceny Hopp Homes",
      desc: "Vypočítajte si cenu svojho vysnívaného domu v 4 jednoduchých krokoch!",
      baseInfo: "Základné informácie",
      extrasSelect: "Vyberte príplatky",
      transportDesign: "Doprava a plánovanie",
      netArea: "Čistá plocha m²",
      roofType: "Typ strechy",
      permitLabel: "Stavebné povolenie",
      transportDistance: "Vzdialenosť dopravy (km)",
      designMode: "Režim návrhu",
      flatRoof: "Plochá strecha (základ)",
      gableRoof: "Sedlová strecha (+50.000 Ft/m²)",
      permitYes: "Áno (5% DPH)",
      permitNo: "Nie (27% DPH)",
      extrasLabels: {
        bathroom: "Kúpeľňa",
        kitchen: "Kuchyňa",
        floorHeating: "Podlahové kúrenie",
        blinds: "Rolety + sieťky",
        crane: "Žeriav"
      }
    },
    de: {
      summary: "Kalkulationsübersicht",
      area: "Fläche:",
      roof: "Dach:",
      permit: "Baugenehmigung:",
      distance: "Transportentfernung:",
      design: "Planungsmodus:",
      extras: "Extras:",
      noExtras: "Keine Extras ausgewählt",
      netto: "Nettopreis:",
      vat: "MwSt:",
      brutto: "Bruttopreis:",
      download: "PDF herunterladen",
      calc: "Berechnen",
      yes: "Mit Genehmigung",
      no: "Ohne Genehmigung",
      title: "Hopp Homes Preisrechner",
      desc: "Berechnen Sie den Preis Ihres Traumhauses in 4 einfachen Schritten!",
      baseInfo: "Grundinformationen",
      extrasSelect: "Extras auswählen",
      transportDesign: "Transport und Planung",
      netArea: "Nettofläche m²",
      roofType: "Dachtyp",
      permitLabel: "Baugenehmigung",
      transportDistance: "Transportentfernung (km)",
      designMode: "Planungsmodus",
      flatRoof: "Flachdach (Basis)",
      gableRoof: "Satteldach (+50.000 Ft/m²)",
      permitYes: "Ja (5% MwSt)",
      permitNo: "Nein (27% MwSt)",
      extrasLabels: {
        bathroom: "Badezimmer",
        kitchen: "Küche",
        floorHeating: "Fußbodenheizung",
        blinds: "Rollläden & Insektenschutz",
        crane: "Kranservice"
      }
    }
  };
  const lang = (window?.localStorage?.getItem('lang') || 'hu').toLowerCase();
  const t = translations[lang] || translations.hu;

  const [form, setForm] = useState({
    area: 54,
    roof: "flat",
    permit: "no", // alapértelmezett: nem engedélyes
    distance: 50,
    design: "no", // alapértelmezett: nem kér tervezést
    extras: {
      bathroom: false,
      kitchen: false,
      floorHeating: false,
      blinds: false,
      crane: false
    }
  });
  const [result, setResult] = useState(null);

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    if (name in form.extras) {
      setForm({ ...form, extras: { ...form.extras, [name]: checked } });
    } else {
      setForm({ ...form, [name]: type === "number" ? Number(value) : value });
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    setResult(calculatePrice(form));
  }

  return (
    <div className="w-full">
      {/* Két oszlopos layout nagyobb képernyőn */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        {/* BAL OSZLOP: Űrlap */}
        <div className="space-y-4">
          <form onSubmit={handleSubmit} className="space-y-4">
            
            {/* 1. Alapadatok */}
            <div className="bg-white/5 rounded-lg p-4">
              <h2 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                <span className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center text-sm">1</span>
                {t.baseInfo || "Alapinformációk"}
              </h2>
              <div className="space-y-3">
                <label className="block">
                  <span className="text-white text-sm font-medium">{t.netArea || "Nettó hasznos m²"}:</span>
                  <input type="number" name="area" min={20} max={150} value={form.area} onChange={handleChange} 
                    className="mt-1 w-full px-3 py-2 bg-white text-gray-900 rounded-md border-0 text-sm" />
                </label>
                <label className="block">
                  <span className="text-white text-sm font-medium">{t.roofType || "Tetőkialakítás"}:</span>
                  <select name="roof" value={form.roof} onChange={handleChange} 
                    className="mt-1 w-full px-3 py-2 bg-white text-gray-900 rounded-md border-0 text-sm">
                    <option value="flat">{t.flatRoof || "Lapostető (alapár)"}</option>
                    <option value="gable">{t.gableRoof || "Nyeregtető (+50.000 Ft/m²)"}</option>
                  </select>
                </label>
                <label className="block">
                  <span className="text-white text-sm font-medium">{t.permitLabel || "Építési engedély"}:</span>
                  <select name="permit" value={form.permit} onChange={handleChange} 
                    className="mt-1 w-full px-3 py-2 bg-white text-gray-900 rounded-md border-0 text-sm">
                    <option value="no">{t.permitNo || "Nincs (27% ÁFA)"}</option>
                    <option value="yes">{t.permitYes || "Van (5% ÁFA)"}</option>
                  </select>
                </label>
              </div>
            </div>

            {/* 2. Extrák */}
            <div className="bg-white/5 rounded-lg p-4">
              <h2 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                <span className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center text-sm">2</span>
                {t.extrasSelect || "Extrák kiválasztása"}
              </h2>
              <div className="grid grid-cols-2 gap-2">
                {alapExtrak.map(ex => (
                  <label key={ex.key} className="flex items-center gap-2 p-2 bg-white/5 rounded cursor-pointer hover:bg-white/10 transition">
                    <input type="checkbox" name={ex.key} checked={form.extras[ex.key]} onChange={handleChange} 
                      className="w-4 h-4 accent-secondary" />
                    <span className="text-white text-sm">{t.extrasLabels?.[ex.key] || ex.key}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* 3. Szállítás */}
            <div className="bg-white/5 rounded-lg p-4">
              <h2 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                <span className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center text-sm">3</span>
                {t.transportDesign || "Szállítás és tervezés"}
              </h2>
              <div className="space-y-3">
                <label className="block">
                  <span className="text-white text-sm font-medium">{t.transportDistance || "Szállítási távolság (km)"}:</span>
                  <input type="number" name="distance" min={0} max={500} value={form.distance} onChange={handleChange} 
                    className="mt-1 w-full px-3 py-2 bg-white text-gray-900 rounded-md border-0 text-sm" />
                </label>
                <label className="block">
                  <span className="text-white text-sm font-medium">{t.designMode || "Tervezési mód"}:</span>
                  <select name="design" value={form.design} onChange={handleChange} 
                    className="mt-1 w-full px-3 py-2 bg-white text-gray-900 rounded-md border-0 text-sm">
                    <option value="no">{t.no || "Nem engedélyes"}</option>
                    <option value="yes">{t.yes || "Engedélyes"}</option>
                  </select>
                </label>
              </div>
            </div>

          </form>
        </div>

        {/* JOBB OSZLOP: Összegzés */}
        <div className="bg-gradient-to-br from-green-900/30 to-green-800/20 rounded-lg p-4 border border-green-500/30">
          <h2 className="text-lg font-bold text-green-400 mb-4 flex items-center gap-2">
            💰 {t.summary}
          </h2>
          
          {/* Összegzés részletek */}
          <div className="space-y-2 text-sm mb-4">
            <div className="flex justify-between text-gray-300">
              <span>{t.area}</span>
              <span className="font-semibold text-white">{form.area} m²</span>
            </div>
            <div className="flex justify-between text-gray-300">
              <span>{t.roof}</span>
              <span className="text-white">{form.roof === "gable" ? "Nyeregtető" : "Lapostető"}</span>
            </div>
            <div className="flex justify-between text-gray-300">
              <span>{t.permit}</span>
              <span className="text-white">{form.permit === "yes" ? "5% ÁFA" : "27% ÁFA"}</span>
            </div>
            <div className="flex justify-between text-gray-300">
              <span>{t.distance}</span>
              <span className="text-white">{form.distance} km</span>
            </div>
            {Object.entries(form.extras).filter(([_, v]) => v).length > 0 && (
              <div className="pt-2 border-t border-white/10">
                <span className="text-gray-300">{t.extras}</span>
                <div className="flex flex-wrap gap-1 mt-1">
                  {Object.entries(form.extras).filter(([_, v]) => v).map(([k]) => (
                    <span key={k} className="bg-secondary/20 text-secondary px-2 py-0.5 rounded text-xs">{t.extrasLabels?.[k] || k}</span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Árak */}
          <div className="bg-black/30 rounded-lg p-3 space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-gray-400 text-sm">{t.netto}</span>
              <span className="font-bold text-white text-lg">{result ? result.netto.toLocaleString('hu-HU') : '—'} Ft</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-400 text-sm">{t.vat}</span>
              <span className="text-white">{result ? result.afa.toLocaleString('hu-HU') : '—'} Ft</span>
            </div>
            <div className="flex justify-between items-center pt-2 border-t border-white/[0.08]">
              <span className="text-green-400 font-bold">{t.brutto}</span>
              <span className="font-extrabold text-green-400 text-xl">{result ? result.brutto.toLocaleString('hu-HU') : '—'} Ft</span>
            </div>
          </div>

          {/* Alapár info */}
          <div className="mt-3 p-2 bg-yellow-500/10 rounded border border-yellow-500/30 text-center">
            <p className="text-yellow-400 text-xs">💡 Alapár: <strong>nettó 370.000 Ft / hasznos m²</strong> (lapostető)</p>
          </div>

          {/* Kalkuláció gomb */}
          <button type="button" onClick={handleSubmit} 
            className="w-full mt-4 bg-secondary hover:bg-hover text-white font-bold py-3 rounded-md transition-all duration-200 text-sm">
            🧮 {t.calc}
          </button>

          {result && <div className="mt-3"><DownloadButton result={result} form={form} downloadLabel={t.download} /></div>}
        </div>
      </div>
    </div>
  );
}
